import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "reduxStore";
import { selectAreLearningCategoriesLoading, selectLearningCategories } from "selectors/learningCategory";
import { getLearningCategoriesAction } from "slices/learningCategories";
import FlexItem from "./shared/layout/FlexItem";
import FlexContainer from "./shared/layout/FlexContainer";
import { H1, H2 } from "./shared/primitives/Heading";
import Paragraph from "./shared/primitives/Paragraph";
import { ButtonAsLink } from "./shared/primitives/Button";
import { routes } from "config";
import Link from "./shared/primitives/Link";
export default function LearningCategories() {
    const dispatch = useAppDispatch();
    const learningCategories = useSelector(selectLearningCategories);
    const isLoadingLearningCategories = useSelector(selectAreLearningCategoriesLoading);
    const getLearningCategories = () => dispatch(getLearningCategoriesAction());
    useEffect(() => {
        getLearningCategories();
    }, []);
    return (React.createElement(FlexContainer, { fullWidth: true, flexDirection: "column" },
        React.createElement(FlexItem, { column: 1 / 1 },
            React.createElement(H1, { solo: true, color: "primary" }, "Online-Schulung")),
        React.createElement(FlexItem, { column: 1 / 1 },
            React.createElement(Paragraph, null, "Liebe Sprachmittler:innen,"),
            React.createElement(Paragraph, null, "in Zusammenarbeit mit Prof. Bernd Meyer und Dr. Feyza Evrin haben wir f\u00FCr Euch eine Online-Schulung mit drei Modulen entwickelt: Dolmetschkompetenz, Sachkompetenz und Sprachkompetenz. Ihr k\u00F6nnt die Inhalte im eigenen Tempo von zu Hause bearbeiten; die Teilnahme ist freiwillig."),
            React.createElement(Paragraph, null, "Nach dem erfolgreichen Abschluss aller Module erhaltet Ihr von uns einen Nachweis. Zu Beginn jedes Moduls findet Ihr die Lernziele sowie eine kurze Orientierung zum Ablauf. Wir w\u00FCnschen Euch viel Freude beim Lernen und hoffen, dass Ihr Euch dabei gezielt weiterbilden k\u00F6nnt."),
            React.createElement(Paragraph, null,
                "F\u00FCr alle, die noch tiefer in das Thema der Sprachmittlung einsteigen m\u00F6chten, empfehlen wir das",
                " ",
                React.createElement(Link, { href: "https://www.peterlang.com/document/1294504", target: "_blank" }, "Buch von Feyza Evrin und Bernd Meyer (kostenlos als PDF verf\u00FCgbar)"),
                "."),
            React.createElement(Paragraph, null,
                "Bei Fragen wendet Euch bitte an:",
                " ",
                React.createElement(Link, { href: "mailto:qualifizierung@triaphon.org" }, "qualifizierung@triaphon.org"),
                ".")),
        !isLoadingLearningCategories && (React.createElement(FlexContainer, { flexWrap: "wrap", fullWidth: true }, learningCategories.map((lc, i) => (React.createElement(FlexItem, { key: lc.id, display: "flex", flexDirection: "column", flexGrow: 1, flexShrink: 0, alignItems: "center", backgroundColor: i % 2 === 0 ? "lightGray" : "white", desktop: { padding: "3rem 5%" }, column: 1 / 1 },
            React.createElement(H2, null, lc.name),
            React.createElement(ButtonAsLink, { to: routes.learningCategories(`/${lc.id}`) }, "Kategorie anzeigen"))))))));
}
